<script>
/*eslint-disable*/
import { gmapApi } from "vue2-google-maps";
import { getZIPMapFeatures } from "@/api/demographics";

export default {
  name: "compset-map",
  props: ["category", "locations"],
  data() {
    return {
      map: null,
      center: { lat: 39.1511025, lng: -84.42251859999999 },
      dataMaxVal: Number.MAX_VALUE,
      dataMinVal: -Number.MAX_VALUE,
      geoJsonData: null,
      featureValue: "-",
      featureId: "-"
    };
  },
  computed: {
    google: gmapApi
  },
  mounted() {
    setTimeout(() => {
      this.initMap(this.locations);
    }, 2000);
  },
  watch: {
    category: function() {
      this.clearCensusData();
      this.loadCensusData();
    }
  },
  methods: {
    initMap(locations) {

      this.$refs.mapRef.$mapPromise.then(map => {
        this.map = map;
        let bounds = new google.maps.LatLngBounds();
        let infowindow = new google.maps.InfoWindow(); 
        for (let i = 0; i < locations.length; i++) {
          let marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i].latitude, locations[i].longtitude),
            map
          });

          //extend the bounds to include each marker's position
          bounds.extend(marker.position);

          google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
              infowindow.setContent(`${locations[i].id} ${locations[i].name} ${locations[i].full_address}`);
              infowindow.open(map, marker);
            }
          })(marker, i));


          getZIPMapFeatures(locations[i].id, "ZIP")
          .then(data => {
            this.geoJsonData = data;
            this.loadMapShapes();
          })
          .catch(e => console.log("ERR", e));
        }

        //now fit the map to the newly inclusive bounds
        this.map.fitBounds(bounds);

        //(optional) restore the zoom level after the map is done scaling
        // let listener = google.maps.event.addListener(map, "idle", function () {
        //     map.setZoom(3);
        //     google.maps.event.removeListener(listener);
        // });

        this.map.data.setStyle(this.styleFeature);
        this.map.data.addListener("mouseover", this.mouseInToRegion);
        this.map.data.addListener("mouseout", this.mouseOutOfRegion);
        this.map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(
          this.$refs.legend
        );
        this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(
          this.$refs.variable
        );
      });
    },
    loadMapShapes() {
      
      const geoJson = {
        type: "FeatureCollection",
        features: this.geoJsonData.filter(data => data && data.map_feature).map(
          data => data.map_feature.map_feature_json
        )
      };
      if (this.geoJsonData.length === 0) {
        return;
      }
      this.map.data.addGeoJson(geoJson, {
        idPropertyName: this.geoJsonData[0].map_feature.json_id_name
      });
      this.clearCensusData();
      this.loadCensusData();
    },
    loadCensusData() {
      let bounds = new this.google.maps.LatLngBounds();
      let featureBounds;
      this.geoJsonData
        .filter(row => row.type == this.category)
        .forEach(row => {
          const censusVariable = parseFloat(row.value);
          const zipId = row.map_feature.json_id_value;

          if (censusVariable < this.dataMinVal) {
            this.dataMinVal = censusVariable;
          }

          if (censusVariable > this.dataMaxVal) {
            this.dataMaxVal = censusVariable;
          }
          const zip = this.map.data.getFeatureById(zipId);

          if (zip) {
            zip.setProperty("census_variable", censusVariable);

            if (
              row.map_feature.map_feature_json.geometry.coordinates[0][0]
                .length == 2
            ) {
              featureBounds = {
                lng: parseFloat(
                  row.map_feature.map_feature_json.geometry.coordinates[0][0][0]
                ),
                lat: parseFloat(
                  row.map_feature.map_feature_json.geometry.coordinates[0][0][1]
                )
              };
              bounds.extend(featureBounds);
            }
          }
        });
      this.map.fitBounds(bounds);
    },
    clearCensusData() {
      this.dataMinVal = Number.MAX_VALUE;
      this.dataMaxVal = -Number.MAX_VALUE;
      this.map.data.forEach(row => {
        row.setProperty("census_variable", undefined);
      });
    },
    styleFeature(feature) {
      const percentage = feature.getProperty("census_variable");
      const colorIntensity = Math.ceil(percentage / 10) / 10;
      let showRow = true;

      if (!percentage || isNaN(feature.getProperty("census_variable"))) {
        showRow = false;
      }
      let outlineWeight = 0.5,
        zIndex = 1;

      if (feature.getProperty("state") === "hover") {
        outlineWeight = zIndex = 2;
      }

      return {
        strokeWeight: outlineWeight,
        strokeColor: "#3f4254",
        zIndex: zIndex,
        fillColor: `rgba(88, 102, 219, ${colorIntensity})`,
        fillOpacity: 0.75,
        visible: showRow
      };
    },
    mouseInToRegion(e) {
      // set the hover state so the setStyle function can change the border
      e.feature.setProperty("state", "hover");
      this.featureValue = e.feature.getProperty("census_variable");
      this.featureId = e.feature.getId();
    },
    mouseOutOfRegion(e) {
      // reset the hover state, returning the border to normal
      e.feature.setProperty("state", "normal");
      this.featureValue = "-";
      this.featureId = "-";
    }
  }
};
</script>

<style scoped>
.legend {
  background: white;
  padding: 1.5rem;
  font-size: 1rem;
  border-radius: 5px;
  min-width: 140px;
}
.legend__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.legend__color {
  width: 10px;
  height: 10px;
}

.variable {
  background: white;
  padding: 1rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid #3f4254;
}
</style>

<template>
  <div>
    <GmapMap
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      }"
      :center="center"
      :zoom="10"
      style="width:100%;  height: 500px;"
      ref="mapRef"
    >
    </GmapMap>

    <div ref="legend" class="legend">
      <div class="legend__row" v-for="i in 10" :key="i">
        <div
          class="legend__color"
          v-bind:style="{ background: `rgba(88, 102, 219, ${i * 0.1})` }"
        ></div>
        <div>
          {{ Number(i * 10 - 9.9).toFixed(1) }}-{{ Number(i * 10).toFixed(1) }}
          %
        </div>
      </div>
    </div>

    <div ref="variable" class="variable">
      <div>ZIP: {{ featureId }}</div>
      <div>Value: {{ featureValue }}%</div>
    </div>
  </div>
</template>
